import React from 'react';
import { modifiers } from '@outdoria/ui';
import { Size } from '@outdoria/ui';
import { icons, type IconType as AssetIconType } from '../../assets/icons';

import s from './Icon.module.scss';

type Props = {
  className?: string;
  spin?: boolean;
  icon?: AssetIconType;
  size?: Size | number;
} & Omit<React.CSSProperties, 'width' | 'height'>;

export const Icon = (props: Props): JSX.Element => {
  const { spin = false, size = Size.SMALL, icon } = props;
  const SVG = icons[icon || 'Unknown'] ?? icons['Unknown'];

  return (
    <span className={modifiers(s, 'icon', String(size))}>
      <SVG className={modifiers(s, 'icon__svg', { spin })} />
    </span>
  );
};
